import { combineEpics, type Epic } from 'redux-observable';
import { filter, from, mergeMap, map, catchError, of } from 'rxjs';
import { listUserAccommodationRequests } from '@/api/istaff/accommodationRequests';
import { fetchMyRequestsCount, setMyRequestsCount } from '../actions';

const fetchMyRequestsCountEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchMyRequestsCount.match),
    mergeMap(() =>
      from(listUserAccommodationRequests({ per_page: 1 })).pipe(
        map((res) => setMyRequestsCount(res.meta.total)),
        catchError(() => of(setMyRequestsCount(0))),
      ),
    ),
  );

export default combineEpics(fetchMyRequestsCountEpic);
